import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";

export class ContextCard extends HasProjectMixin(Model) {
  static get $name() {
    return "ContextCard";
  }

  declare id: number | string;
  declare isPhantom: boolean;
  declare board: number;
  declare cardType: string;
  declare content: string;
  declare isEnabled: boolean;
  declare isDraft: boolean;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number;
  declare updater: number;

  static get fields() {
    return [
      "id",
      { name: "board", type: "number" },
      { name: "cardType", dataSource: "card_type", type: "string" },
      { name: "content", type: "string" },
      { name: "isEnabled", dataSource: "is_enabled", type: "boolean", defaultValue: true },
      { name: "isDraft", dataSource: "is_draft", type: "boolean", persist: false }, // Keep for backend reference, don't persist from frontend
      { name: "createdAt", dataSource: "created_at", type: "date", persist: false },
      { name: "updatedAt", dataSource: "updated_at", type: "date", persist: false },
      { name: "creator", type: "number", persist: false },
      { name: "updater", type: "number", persist: false },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
ContextCard.exposeProperties();